import { ILanguage, Language } from "@/services/DTOs/Language";

export interface IOpportunityLanguage {
  fluency: string;
  language: ILanguage;
}

export class OpportunityLanguage {
  public fluency: string;
  public language: Language;

  constructor(data: IOpportunityLanguage) {
    this.fluency = data.fluency;
    this.language = new Language(data.language);
  }
}
